import { PartnerApplyPage } from '../features/partner/PartnerApplyPage';

const ParceiroAplicarPage: React.FC = () => <PartnerApplyPage />;

export default ParceiroAplicarPage;
